// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","copyrightText":"App_copyrightText__FaXo8"};